import { FunctionComponent, useEffect, useState } from "react";
import styles from "./PublishPopupSingle.module.css";
import {
  CustomTextField,
  InputPropsStyleForInvoice,
  checking,
  formatNumberWithCommas,
  listTicketsRowType,
  splitLocation,
} from "../../../helper";
import { Button, InputAdornment } from "@mui/material";
import { useForm } from "react-hook-form";
import images from "../../../assets/images/index";
import ToasterWithMessage from "../toaster";

interface EditPricePopUpProps {
  row: listTicketsRowType;
  handleCloseDialog: () => void;
  handleAllow: any;
}

const InputField = CustomTextField();

const EditPricePopUp: FunctionComponent<EditPricePopUpProps> = ({
  row,
  handleCloseDialog,
  handleAllow,
}) => {
  const {
    register,
    handleSubmit,
    reset,
    watch,
    setValue,
    setError,
    trigger,
    formState: { errors },
  } = useForm({
    defaultValues: {section: "", rows: "", seatno: "",  listPrice: "" },
    mode: "onTouched",
  });
  const [listprice, setListPrice] = useState<string>("");
  const [errorForZero, setErrorForZero] = useState<string>("");
  const [disableBtn,setDisableBtn] = useState<boolean>(true);
  const [ticketSection, setSection] = useState<string>("");
  const [ticketRow, setRow] = useState<string>("");
  const [ticketSeatNo, setSeatNo] = useState<string>("");
  const { CloseIcon } = images;
  const { error } = ToasterWithMessage();

  useEffect(() => {
    setValue('section', row.tp_section);
    setValue('rows', row.tp_row);
    setValue('seatno', row.tp_seat_no?.toString());
    setValue('listPrice', row.tp_list_price?.toString());
    setListPrice(row.tp_list_price?.toString());
  }, [])

  const handleChangeSection = (e: React.ChangeEvent<HTMLInputElement>) => {
    const input = e.target.value;
    setValue('section', input);
    setSection(input);
    trigger('section');
  };
  const handleChangeRow = (e: React.ChangeEvent<HTMLInputElement>) => {
    const input = e.target.value;
    setValue('rows', input);
    setRow(input);
    trigger('rows');
  };

  const handleChangeSeatNo = (e: React.ChangeEvent<HTMLInputElement>) => {
    const input = e.target.value;
    const regexPattern = /^[0-9 ]+$/;
    if (regexPattern.test(input) && input.trim() !== ""){
        setValue('seatno',input);
        setSeatNo(input);
        trigger('seatno');
    } else {
      setValue('seatno',ticketSeatNo)
      setSeatNo(ticketSeatNo);
    }
  };

  const handleRowKeyDown = (e :any) =>{
    if(e.key === 'Backspace'){
      if(ticketRow.length === 1){
        setRow("")
      }
    }
  }
  const handleSeatNoKeyDown = (e :any) =>{
    if(e.key === 'Backspace'){
      if(ticketSeatNo.length === 1){
        setSeatNo("")
      }
    }
  }

  const handleSubmitListPrice = (formData: { listPrice: string, section: string, rows: string, seatno: string }) => {
    if(formData?.listPrice === row?.tp_list_price?.toString() && formData?.section === row?.tp_section && formData?.rows === row?.tp_row && formData?.seatno === row?.tp_seat_no?.toString()) {
      error('Please edit anything to update!');
    } else {
      const regex=/^(?!\.).*(?<!\.)$/;
      if (
        parseFloat(formData?.listPrice) <= 0
      ) {
        setErrorForZero("Price should be greater than zero");
      } else if(regex.test(formData?.listPrice)){
        const data = {
          ...formData,
          e_id: row?.e_id,
          tp_id: row?.tp_id
        }
        handleAllow(data);
      } else {
        setError('listPrice',{
          type: 'manual',
          message: "Enter a valid List Price",
        })
      }
    }
  };

  const handleResetListprice = () =>{
    setListPrice('');
    setDisableBtn(true);
  }

  const handleChangeListPrice = (e: React.ChangeEvent<HTMLInputElement>) => {
    const input = e.target.value;
    setErrorForZero("");
    const regexPattern = /^(0|[1-9]\d*)(\.\d{0,2})?$/;
    if (regexPattern.test(input)) {
      if (parseFloat(input) <= 100000 && parseFloat(input) >= 0) {
        setValue("listPrice", input);
        setListPrice(input);
        trigger("listPrice");
      }
    } else {
      setListPrice(listprice);
    }
  };

  const handleKeyDown = (e :any) =>{
    if(e.key === 'Backspace'){
      if(listprice.length === 1){
        setListPrice("")
      }
    }
  }
  const watchField = watch(['section', 'rows', 'seatno', 'listPrice']);
  useEffect(() => {
    const [section, rows, seatno, listPrice] = watchField;
    setDisableBtn(listPrice === String(row?.tp_list_price) && section === row?.tp_section && rows === row?.tp_row && seatno === row?.tp_seat_no?.toString());
  }, [watchField, row?.tp_list_price]);

  return (
    <form onSubmit={handleSubmit(handleSubmitListPrice)} autoComplete="off">
      <div className={styles.markAsSold}>
        <div className={styles.title}>
          <b className={styles.markAsSoldTitle}>Edit Ticket Details</b>
          <div className={styles.closeicon}>
            <img src={CloseIcon} alt="closeicon" onClick={handleCloseDialog} />
          </div>
        </div>
        <div className={styles.eventDetailsAndLogitixSoldPrice}>
          <div className={styles.eventDetailsPrice}>
            <div className={styles.eventDetails1Price}>Event Details</div>
            <div className={styles.eventDetails2Price}>
              <div className={styles.eventPrice}>
                <b className={styles.date}>Event</b>
                <b className={styles.rocketsVsMemphisPrice}>{row?.e_name}</b>
              </div>
              <div className={styles.eventPrice}>
                <b className={styles.date}>Date</b>
                <b className={styles.rocketsVsMemphisPrice}>
                  {checking(row?.e_date).date} /&nbsp;
                  {checking(row?.e_date).time}
                </b>
              </div>
              <div className={styles.eventPrice}>
                <b className={styles.date}>Venue</b>
                <b className={styles.rocketsVsMemphisPrice}>
                  {splitLocation(row?.e_address).firstWord}
                  {splitLocation(row?.e_address).remainingWords}
                </b>
              </div>
              <div className={styles.eventPrice}>
                <b className={styles.date}>Ticket Placement</b>
                <b className={styles.secA}>
                  Sec : {row?.tp_section} / Row : {row?.tp_row} / Seat : {row?.tp_seat_no}
                </b>
              </div>
              <div className={styles.eventPrice}>
                <b className={styles.date}>List Price</b>
                <b className={styles.secA}>
                  ${formatNumberWithCommas(row?.tp_list_price)}
                </b>
              </div>
            </div>
          </div>
          <div className={styles.eventDetails1Price}>Ticket Details</div>
          <div className={styles.bg}>
              <div className={styles.eventDetailsEditTicket}>
                <div className={styles.section}>
                <div className={styles.transactionId}>
                  <b className={styles.date}>Enter section</b>
                  <span className={styles.errorMsgSectionStyle}>
                        { errors?.section?.message}
                  </span>
                </div>
                  <div className={styles.textFieldSection}>
                    <div className={styles.container}>
                      <InputField
                        sx={{
                          "& input": {
                            height: "0.0375em",
                            textTransform:"capitalize"
                          },
                        }}
                        classes={{
                          root: styles.sectiondiv,
                        }}
                        {...register("section", {
                          required: "Section is required!",
                          pattern: {
                            value: /^[a-zA-Z0-9\s\-'._/,&()]+$/,
                            message: 'Enter valid section'
                          },
                          maxLength: {
                            value: 32,
                            message: "Maximum of 32 characters",
                          },
                        })}
                        InputProps={{
                          style: InputPropsStyleForInvoice,
                        }}
                        placeholder={`Enter section`}
                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleChangeSection(e)}
                        error={Boolean(errors?.section?.message)}
                      />
                    </div>
                  </div>
                </div>
                <div className={styles.row}>
                <div className={styles.transactionId}>
                  <b className={styles.date}>Enter row</b>
                  <span className={styles.errorMsgRowStyle}>
                        { errors?.rows?.message}
                  </span>
                </div>
                  <div className={styles.textFieldRow}>
                    <div className={styles.container}>
                      <InputField
                        sx={{
                          "& input": {
                            height: "0.0375em",
                            textTransform:"capitalize"
                          },
                        }}
                        classes={{
                          root: styles.rowdiv,
                        }}
                        {...register("rows", {
                          required: "Row is required!",
                          pattern: {
                            value: /^[a-zA-Z0-9\s\-'._/,&()]+$/,
                            message: 'Enter valid row'
                          },
                          maxLength: {
                            value: 32,
                            message: "Maximum of 32 characters",
                          },  
                          })}
                        // value={row}
                        InputProps={{
                          style: InputPropsStyleForInvoice,
                        }}
                        placeholder={`Enter row`}
                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleChangeRow(e)}
                        error={Boolean(errors?.rows?.message)}
                        onKeyDown={handleRowKeyDown}
                      />
                    </div>
                  </div>
                </div>
                <div className={styles.seatno}>
                <div className={styles.transactionId}>
                  <b className={styles.date}>Enter seat no</b>
                  <span className={styles.errorMsgRowStyle}>
                        { errors?.seatno?.message}
                  </span>
                </div>
                  <div className={styles.textFieldSeatno}>
                    <div className={styles.container}>
                      <InputField
                        sx={{
                          "& input": {
                            height: "0.0375em",
                            textTransform:"capitalize"
                          },
                        }}
                        classes={{
                          root: styles.seatnodiv,
                        }}
                        {...register("seatno", {
                          required: "Seat no is required!",
                          pattern: {
                            value: /^[0-9]+(?: [0-9]+)*$/,
                            message: 'Enter valid seat no'
                          },
                          maxLength: {
                            value: 32,
                            message: "Maximum of 32 digits are allowed",
                          },  
                          })}
                        // value={row}
                        InputProps={{
                          style: InputPropsStyleForInvoice,
                        }}
                        placeholder={`Enter seat no`}
                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleChangeSeatNo(e)}
                        error={Boolean(errors?.rows?.message)}
                        onKeyDown={handleSeatNoKeyDown}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>

        
          <div className={styles.logitixSoldPrice}>
            <div className={styles.eventDetails1Price}>List Price</div>
            <div className={styles.bg}>
              <div className={styles.eventDetailsPrice}>
                <div className={styles.soldPrice}>
                <div className={styles.transactionId}>
                  <b className={styles.date}>Enter amount</b>
                  <span className={styles.errorMsgListPriceStyle}>
                        { errorForZero  || errors?.listPrice?.message}
                  </span>
                </div>
                  <div className={styles.textField}>
                    <div className={styles.container}>
                      <InputField
                        sx={{
                          "& input": {
                            height: "0.0375em",
                          },
                        }}
                        classes={{
                          root: styles.amountdivPrice,
                        }}
                        {...register("listPrice", {
                          required: "List price is required!",
                        })}
                        value={listprice}
                        InputProps={{
                          style: InputPropsStyleForInvoice,
                          startAdornment: (
                            <InputAdornment position="start">
                              $
                            </InputAdornment>
                          ),
                        }}
                        placeholder={watch('listPrice') ? "" : `Eg,. $121.00`}
                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleChangeListPrice(e)}
                        error={Boolean(errors?.listPrice?.message)}
                        onKeyDown={handleKeyDown}
                      />
                    </div>
                  </div>
                </div>
             
                
              </div>
            </div>
          </div>
        </div>
        <div className={styles.cta}>
          <div className={styles.buttons} onClick={handleResetListprice}>
            <Button
              classes={{ root: styles.separateStyleforcancel }}
              fullWidth
              disableRipple
            >
              Reset
            </Button>
          </div>
          <div className={disableBtn?styles.disabledButton:styles.buttons1}>
            <Button
              classes={{ root: disableBtn 
                ? styles.separateStyledisabledUpdateBtn
                : styles.separateStyle }}
              disableRipple
              fullWidth
              type="submit"
              disabled={disableBtn}
            >
              Update
            </Button>
          </div>
        </div>
      </div>
    </form>
  );
};

export default EditPricePopUp;
